import React from 'react';
import { StarIcon, DownloadIcon, ArrowRightIcon } from 'lucide-react';
const GUIDE_URL = 'https://drive.google.com/file/d/1XiYPPzkfIjpNUBqir0XvQvJX1imqKfKj/view?usp=sharing';
export function ThankYouPage() {
  return <main className="min-h-screen w-full bg-[#f8f7f4] text-[#1e293b] font-sans selection:bg-[#b91c1c] selection:text-white flex flex-col items-center justify-start p-4 sm:p-8 relative overflow-hidden" data-id="element-1883">
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/stardust.png')]" data-id="element-1884"></div>

      {/* Subtle Gradient Glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-96 bg-[#dbeafe] opacity-40 blur-[120px] rounded-full pointer-events-none" data-id="element-1885"></div>
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-[#fecaca] opacity-20 blur-[100px] rounded-full pointer-events-none" data-id="element-1886"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto space-y-8 py-8 sm:py-12" style={{
      marginLeft: '0px',
      marginRight: '0px'
    }} data-id="element-1887">
        {/* Header */}
        <div className="space-y-4" data-id="element-1888">
          <p className="text-lg italic text-[#475569] leading-relaxed px-6 sm:px-8" data-id="element-1889">
            Thank you for requesting{' '}
            <span className="font-semibold text-[#0f172a] not-italic" data-id="element-1890">
              "Endless Clean Water: The DIY Biosand System"
            </span>
            . You can download it by clicking the link below…
          </p>
        </div>

        {/* Content Section */}
        <div className="overflow-hidden" data-id="element-1891">
          <div className="space-y-8" data-id="element-1892">
            {/* Content Card */}
            <div className="" data-id="element-1893">
              <div className="p-6 sm:p-8 space-y-8" data-id="element-1894">
                {/* Section 1: Download */}
                <section className="space-y-4" data-id="element-1895">
                  <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#0f172a]" data-id="element-1896">
                    Step #1: Download Your{' '}
                    <span className="text-[#b91c1c]" data-id="element-1897">FREE</span> Guide
                  </h2>

                  <a href={GUIDE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-[#002868] font-semibold text-lg underline underline-offset-4 decoration-[#002868]/40 hover:decoration-[#002868] transition-all" style={{
                  fontWeight: '700',
                  color: '#0000EE'
                }} data-id="element-1898">
                    <DownloadIcon className="w-5 h-5 flex-shrink-0" data-id="element-1899" />
                    Endless Clean Water: The DIY Biosand System (click to
                    download)
                  </a>
                </section>

                {/* Divider */}
                <div className="border-t border-[#e2e8f0]" data-id="element-1900"></div>

                {/* Section 2: Next Step */}
                <section className="space-y-4" data-id="element-1901">
                  <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-[#0f172a]" data-id="element-1902">
                    Step #2: Discover How to Create{' '}
                    <span className="text-[#b91c1c]" data-id="element-1903">
                      An On-Demand Water Supply For Your Family
                    </span>{' '}
                    (4 easy steps)
                  </h2>

                  <a href="https://hop.clickbank.net/?affiliate=lourdn&vendor=watersb&tid=TRACKINGID&pid=6" className="inline-flex items-center gap-2 text-[#002868] font-semibold text-lg underline underline-offset-4 decoration-[#002868]/40 hover:decoration-[#002868] transition-all" style={{
                  fontWeight: '700',
                  color: '#0000EE'
                }} data-id="element-1904">
                    <ArrowRightIcon className="w-5 h-5 flex-shrink-0" data-id="element-1905" />
                    Click Here to Learn How to Secure Your Water Supply for Life
                  </a>
                </section>
              </div>

              {/* Red, White, Blue stripe */}
              <div className="h-2 w-full flex" style={{
              marginTop: '100px'
            }} data-id="element-1906">
                <div className="flex-1 bg-[#b91c1c]" data-id="element-1907"></div>
                <div className="flex-1 bg-[#f8f7f4]" data-id="element-1908"></div>
                <div className="flex-1 bg-[#1b2a4a]" data-id="element-1909"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-[#94a3b8] text-xs" data-id="element-1910">
          <p data-id="element-1911">© 2026 PatriotsInformer. All rights reserved.</p>
        </footer>
      </div>
    </main>;
}